const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const api = {
  async get(endpoint) {
    const response = await fetch(`${API_BASE}/api/forecast${endpoint}`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return response.json();
  },

  async post(endpoint, data) {
    const response = await fetch(`${API_BASE}/api/forecast${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return response.json();
  },
};

export const endpoints = {
  dashboard: '/dashboard',
  inventory: '/inventory',
  forecasts: '/forecasts',
  forecast: (sku) => `/forecast/${sku}`,
  reorder: '/reorder',
  salesAnalytics: '/analytics/sales',
  channelAnalytics: '/analytics/channels',
  brandAnalytics: '/analytics/brands',
  stockouts: '/stockouts',
  purchaseOrders: '/purchase-orders',
  promos: '/promos',
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-IN').format(num);
};

export const getStatusColor = (status) => {
  const colors = {
    CRITICAL: 'bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium',
    ORDER_NOW: 'bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium',
    WATCH: 'bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium',
    HEALTHY: 'bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium',
    OVERSTOCK: 'bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium',
  };
  return colors[status] || 'bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs font-medium';
};
